import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Resiliation, MotifMaintenantSchema, ChoixResiliation } from '../model/resiliation';

export enum TypeStep {
  IdentiteAdherant = 0,
  IdentificationContrat = 1,
  ChoixResiliation = 2,
  MotifResiliation = 3,
  recap = 4
}

// Define the initial state using that type
export const initialState = {
  step: 0 as TypeStep,
  inProgress: false,
  resiliation: {
    informations: {
      lastname: '',
      firstname: '',
      dateNaissance: '',
      numTel: '',
      email: '',
      emailComfirmation: '',
      nRue:'',
      adresse:'',
      codePostal:'',
      ville:'',
      
    },
    contrat: {
      produit: '',
      nomContrat: '',
      nomGarantie: '',
      numAdhesion: '',
    },
    choixResil: {

    },
    motifMaintenant: {
      motif: '',
      date: null,
      description: '',
    },
    recap:{

    },
  } as Resiliation
}

export type ResiliationState = typeof initialState;

export const resiliationSlice = createSlice({
  name: 'resiliation',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    firstStep: (state) => {
      state.step = TypeStep.IdentiteAdherant;
      state.resiliation = { ...initialState.resiliation }
    },
    progressing: (state, action: PayloadAction<boolean>) => {
      state.inProgress = action.payload;
    },
    nextStep: (state) => {
      if (state.step < 4) state.step++;
    },
    specificStep: (state, action: PayloadAction<number>) => {
      if (state.step == 4) state.step=action.payload;
    },
    previousStep: (state) => {
      if (state.step > 0) state.step--;
    },
    updateResiliation: (state, action: PayloadAction<{ resiliation: Resiliation }>) => {
      state.resiliation = { ...state.resiliation, ...action.payload.resiliation }
    },
    resiliationSummary: (state) => {
      let values: any = { choix: '', date: null,texte: ''};
      state.resiliation = { ...state.resiliation, ...{ motifMaintenant: { ...values } } }
      state.step=4;
    }
  }

})

export const resiliationActions = resiliationSlice.actions

export default resiliationSlice.reducer
